import { Button, ModalHeader, ModalNext, ModalBody, ModalFooter } from '@jutro/components';
import { useTranslator } from '@jutro/locale';

import styles from './AutoDeactivatePopup.module.scss';
import messages from './AutoDeactivatePopup.messages';
import { messages as commonMessages } from '@xengage/gw-platform-translations';

function AutoDeactivatePopup(props) {
    const translate = useTranslator();
    const { isOpen, onAccept, onResolve, onReject } = props;
    // DE19915 allow for functions to be inserted after accepting terms
    const resolveWrap = result => {
      if (onAccept) {
        onAccept(result);
      }
      onResolve(result);
    };

    return (
        <ModalNext isOpen={isOpen} className={styles.deactivatePopup}>
            <ModalBody>
                <p className={styles.titleBold}>{translate(messages.deactivateTitle1)}</p>
                <p className={styles.title}>
                  <span>{translate(messages.deactivateTitle2_1)}</span>
                  <span className={styles.titleBold}>{translate(messages.deactivateTitle2_2)}</span>
                  <span>{translate(messages.deactivateTitle2_3)}</span>
                </p>
                <p className={styles.bodyHeader}>{translate(messages.deactivateBodyHeader)}</p>
                <ul>
                    <li>
                        <span className={styles.boldStart}>{translate(messages.deactivateBody1_1)}</span>
                        <span>{translate(messages.deactivateBody1_2)}</span>
                    </li>
                    <li>
                        <span>{translate(messages.deactivateBody2_1)}</span> 
                        <span className={styles.bold}>{translate(messages.deactivateBody2_2)}</span>
                    </li>
                    <li>
                        <span>{translate(messages.deactivateBody3_1)}</span> 
                        <span className={styles.bold}>{translate(messages.deactivateBody3_2)}</span>
                        <span>{translate(messages.deactivateBody3_3)}</span>
                        <span className={styles.bold}>{translate(messages.deactivateBody3_4)}</span>
                    </li>
                    <li>
                        <span>{translate(messages.deactivateBody4_1)}</span> 
                        <span className={styles.bold}>{translate(messages.deactivateBody4_2)}</span>
                    </li>
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={resolveWrap}
                    label={translate(messages.accept)}
                />
            </ModalFooter>
        </ModalNext>
    )
}

export default AutoDeactivatePopup;
